import axios from "axios";
import { environment } from "Enviroments";

export interface AccountDeletionRequest {
  email: string;
  name?: string;
  phone?: string;
  reason?: string;
  confirm: true;
}

export interface AccountDeletionResponse {
  id: number | string;
  status: string;
}

export interface AccountDeletionError {
  status: number;
  message?: string;
}

// Public endpoint: uses its own axios instance so no session token is sent and
// the HTTP status survives (the shared Client interceptor drops it).
const PublicClient = axios.create({
  baseURL: environment.url,
  timeout: 30000,
  headers: { "Content-Type": "application/json" },
});

export default class AccountDeletionService {
  public static async create(
    body: AccountDeletionRequest
  ): Promise<AccountDeletionResponse> {
    try {
      const { data } = await PublicClient.post(
        "/account-deletion-requests",
        body
      );
      return data.data;
    } catch (e) {
      const error: AccountDeletionError = {
        status: e.response ? e.response.status : 0,
        message: e.response?.data?.error,
      };
      throw error;
    }
  }
}
